import MasonryGalleryWithDescriptionContainer from "../../Componant/Gallery/MasonryGalleryWithDescription";

const MasonryGalleryWithDescription = () => {
  return (
    <div className="page-body">
      <MasonryGalleryWithDescriptionContainer />
    </div>
  );
};

export default MasonryGalleryWithDescription;
